import React, { useEffect, useState } from "react";
import ReactDOM from 'react-dom';
import { Link } from "react-router-dom";
import { Fade, Slide } from "react-awesome-reveal";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { scrollinit } from "@utils/helper";
import parse from 'html-react-parser';
import { renderToString } from "react-dom/server";
import { useMediaQuery } from "react-responsive";


export const SectionOne: React.FC<any> = (props)=> {
    const {data} = props;
    
const steps = [
  {
    id: 1,
    title: "Buy from us",
    description: "Purchase the\nproduct on\nbrand’s website."
  },
  {
    id: 2,
    title: "Find it\ncheaper?",
    description: "If you spot the same\nitem for less on\nanother site, take a\nscreenshot and copy\nthe link."
  },
  {
    id: 3,
    title: "Submit a\nclaim",
    description: "Fill out our form.\nOnce verified, we’ll\nrefund 2x the price\ndifference."
  }
];

 const isMobile = useMediaQuery({ maxWidth: 768 });
   
    return (
        <>
            <div className="blog-section-details check-privcy" style={{marginBottom:"-40px"}}>
                <div className="container-fluid">
                    <div className="col-12 blog-content" style={{paddingTop:"10px"}}>
                        
                        <h1 className="text-center" >GoKwik’s Best Price Guarantee</h1>
                        <h4 className="text-center"> Shop Confidently — We’ve Got You Covered with 2X the Difference!</h4>
                        <p className="text-center" >Found it cheaper elsewhere than the brand’s own website? We’ll pay you 2x the difference. Just send us a claim within 3 days of purchase. It’s simple, fast, and fair. </p>
                    

                        <h3 className="text-center" >How Our Price Match Guarantee Works</h3>
                            {!isMobile ? (
                                       <div className="d-flex flex-col md:flex-row justify-content-evenly items-start gap-6 p-4" >
                          
                                    <div className="gap-3 d-flex flex-column " >
                                        <div className="text-center" style={{borderRadius:"50%",backgroundColor:"orange", color:"black",height:"70px",width:"70px",paddingTop:"20px"}}>1</div>
                                        <div className="border-1 border d-flex  flex-column p-4" style={{borderRadius:"10px"}}>
                                            <h4 className="">Buy from us</h4>
                                            <div className="text-center" style={{width:"200px",height:"100px"}}>Purchase the product on brand’s website.</div>
                                        </div>
                                    </div>
                                      <div className="gap-3 d-flex flex-column " >
                                        <div className="text-center" style={{borderRadius:"50%",backgroundColor:"orange", color:"black",height:"70px",width:"70px",paddingTop:"20px"}}>2</div>
                                        <div className="border-1 border d-flex  flex-column p-4" style={{borderRadius:"10px"}}>
                                            <h4 className="">Find it cheaper?</h4>
                                            <div className="text-center" style={{width:"200px",height:"100px"}}>If you spot the same item for less on another site, take a screenshot and copy the link.</div>
                                        </div>
                                    </div>
                                      <div className="gap-3 d-flex flex-column " >
                                        <div className="text-center" style={{borderRadius:"50%",backgroundColor:"orange", color:"black",height:"70px",width:"70px",paddingTop:"20px"}}>3</div>
                                        <div className="border-1 border d-flex  flex-column p-4" style={{borderRadius:"10px"}}>
                                            <h4 className="">Submit a claim</h4>
                                            <div className="text-center" style={{width:"200px",height:"100px"}}>Fill out our form.Once verified, we’ll refund  <b>2x the price difference.</b></div>
                                        </div>
                                    </div>
                        </div>
                            ):(
                                  <div className="flex flex-col items-start gap-6 p-4 mt-2"  style={{flexDirection:"column"}}>
                          
                                    <div className="gap-3 d-flex flex-column " >
                                        <div className="text-center" style={{borderRadius:"50%",backgroundColor:"orange", color:"black",height:"70px",width:"70px",paddingTop:"20px"}}>1</div>
                                        <div className="border-1 border d-flex  flex-column p-4" style={{borderRadius:"10px"}}>
                                            <h4 className="">Buy from us</h4>
                                            <div className="text-center" style={{width:"200px",height:"100px"}}>Purchase the product on brand’s website.</div>
                                        </div>
                                    </div>
                                      <div className="gap-3 d-flex flex-column mt-3" >
                                        <div className="text-center" style={{borderRadius:"50%",backgroundColor:"orange", color:"black",height:"70px",width:"70px",paddingTop:"20px"}}>2</div>
                                        <div className="border-1 border d-flex  flex-column p-4" style={{borderRadius:"10px"}}>
                                            <h4 className="">Find it cheaper?</h4>
                                            <div className="text-center" style={{width:"200px",height:"100px"}}>If you spot the same item for less on another site, take a screenshot and copy the link.</div>
                                        </div>
                                    </div>
                                      <div className="gap-3 d-flex flex-column mt-3 " >
                                        <div className="text-center" style={{borderRadius:"50%",backgroundColor:"orange", color:"black",height:"70px",width:"70px",paddingTop:"20px"}}>3</div>
                                        <div className="border-1 border d-flex  flex-column p-4" style={{borderRadius:"10px"}}>
                                            <h4 className="">Submit a claim</h4>
                                            <div className="text-center" style={{width:"200px",height:"100px"}}>Fill out our form.Once verified, we’ll refund <b>2x the price difference.</b></div>
                                        </div>
                                    </div>
                        </div> 
                            )}
                            
                       <div>
                             <h3 className="text-center" >Terms & Conditions</h3>
                            {/* <h5>KwikCod App - Pricing Terms & Conditions</h5> */}
                           
                            <p> <b>Effective Date:</b>04 Jun 2025</p>
                            <p> <b>Version:</b> 1.0</p>
                           
                            <ol>
                                 <hr />
                                <li><b>Policy Overview </b> GoKwik is committed to delivering value to its customers through the "Best Price Guarantee" program. This policy outlines the terms, eligibility criteria, and claim process for customers who find a lower price for an identical product on eligible marketplaces. GoKwik will refund 2x the difference in price to eligible customers, ensuring confidence in every purchase.</li>
                                    <hr />
                                <li><b>Scope</b> This policy applies only to individual retail consumers who make purchases on brand websites powered by GoKwik's checkout platform. It is valid for purchases made in India and limited to eligible eCommerce platforms.</li>
                               <hr />
                                <li><b>Eligible Comparison Platforms</b>
                                <ul>
                                    <li><a  target="_blank" rel="noopener noreferrer" href="http://www.amazon.in">Amazon India  </a> </li>
                                    <li><a  target="_blank" rel="noopener noreferrer" href="http://www.flipkart.com"> Flipkart</a></li>
                                    <li><a  target="_blank" rel="noopener noreferrer" href="http://www.myntra.com"> Myntra</a></li>
                                    <li><a  target="_blank" rel="noopener noreferrer" href="http://www.nykaa.com"> Nykaa</a></li>
                                    <li><a  target="_blank" rel="noopener noreferrer" href="http://www.ajio.com">Ajio </a></li>
                                    <li><a  target="_blank" rel="noopener noreferrer" href="http://www.tirabeauty.com">Tira</a></li>
                                </ul>
                                <ul>
                                    Prices from these platforms must be:
                                    <li>Publicly visible and not hidden behind login or app restrictions.</li>
                                    <li>Applicable to the same delivery region/pin code as the customer’s order.</li>
                                    <li>Inclusive of all taxes, shipping, and additional charges.</li>
                                </ul>
                                </li>  

                                <hr />

                                <li> <b>Product Match Criteria </b>For a product to be eligible under this policy, it must be:
                                    <ul>
                                        <li>The exact same brand and model number.</li>
                                        <li>Identical in color, size, packaging, quantity and specifications.</li>
                                        <li>Sold as a new, unused item. Open-box, refurbished, or used items are excluded.</li>
                                        <li>Manufactured under the same batch or manufacturing date, if applicable.</li>
                                        <p>Bundled products, limited edition versions, and promotional/sample packs are not eligible.</p>
                                    </ul>
                                </li>

                                <hr />
                                <li><b>Purchase Requirements</b> 
                                    <ul>
                                        <li>The order must be placed on a brand’s official website using GoKwik’s checkout platform.</li>
                                        <li>IMPORTANT: Applicable only on prepaid orders. COD orders are not eligible</li>
                                        <li>Claims must be made within 3 calendar days (72 hours) of order confirmation.</li>
                                        <li>Orders partially or fully paid through loyalty points, store credits, or coupons are excluded.</li>
                                        <li>Bulk orders (more than two units of the same product) and COD orders not delivered are ineligible.</li>
                                    </ul>
                                </li>
                                <hr />

                                <li>Claim Submission Process To initiate a claim, customers must submit the following:
                                    <ul>
                                        <li>Valid Order ID</li>
                                        <li>Purchase Date</li>
                                        <li>Product Name </li>
                                        <li>Where did you find it cheaper? </li>
                                        <li>Live URL of the product page with lower pricing</li>
                                        <li>Screenshot of the lower-priced product on the eligible marketplace (timestamped)</li>
                                        <li>UPI/VPA ID for refund processing</li>
                                    </ul>
                                </li>
                                    <p>All claims must be submitted via the official GoKwik Price Match Claim Form: <a target="_blank" rel="noopener noreferrer"   href="https://forms.gle/p6uCg6fTjTutaf9E6">https://forms.gle/p6uCg6fTjTutaf9E6</a></p>
                                <hr />

                                <li><b>Verification & Refund Process</b>
                                    <ul>
                                        <li>Claims will be verified within 5 business days by GoKwik’s verification team.</li>
                                        <li>GoKwik will use tools and methods to verify prices, timestamps, regional availability, and legitimacy of evidence.</li>
                                        <li>If validated, the customer will receive 2x the price difference as a refund to the provided UPI/VPA ID.</li>
                                        <li>No alternate refund modes will be entertained.</li>
                                    </ul>
                                </li>   
                                <hr />

                                <li>
                                    <b> Anti-Fraud Measures</b>GoKwik actively monitors claims for fraudulent or suspicious behavior. Claims will be rejected and users may be blacklisted for:
                                    <ul>
                                        <li>Submitting tampered or edited evidence</li>
                                        <li>Multiple claims across accounts for the same product</li>
                                        <li>Price manipulation through extensions or scripts</li>
                                        <li>Any misrepresentation or abuse of the policy</li>
                                    </ul>
                                </li>
                                <hr />

                                <li>
                                    <b>Exclusions</b>
                                    <ul>
                                        <li>Flash sales, app-only discounts, or time-limited deals</li>
                                        <li>Membership or loyalty-based pricing (e.g., Amazon Prime, Myntra Insider)</li>
                                        <li>Prices using discount coupons, marketplace pay balance/cash credit, cashback extensions, or affiliate discounts</li>
                                    </ul>
                                </li>
                                <hr />

                                <li>
                                    <b>Policy Rights and Changes </b>GoKwik reserves the right to:
                                    <ul>
                                        <li>Modify, suspend, or discontinue the program at any time without prior notice.</li>
                                        <li>Reject any claim that does not adhere to the terms or shows any red flags.</li>
                                        <li>Take the <b>final decision on any claim</b> at its <b>sole discretion</b>, including interpreting the validity and applicability of evidence or price comparisons.</li>
                                    </ul>
                                </li>
                                <hr />

                                <li>
                                    <b>Legal Jurisdiction</b> All disputes arising under this policy shall be governed by the laws of India and subject to the exclusive jurisdiction of courts in New Delhi.
                                </li>

                                <hr />
                                <li> <b>Support</b> For queries related to the Best Price Guarantee, contact:
                                    <ul>
                                        <li><b>Email:</b> support@gokwik.co</li>
                                        <li><b>Working Hours:</b> Monday to Friday, 10:00 AM to 6:00 PM IST
</li>
                                    </ul>
                                </li>
                                </ol>
                                
                          
                       
                    
                </div>
                </div>
                </div>
            </div>
        </>
    )
}
